export default "__VITE_ASSET__BlsiwyUP__"